import page from '../../smartpak/page';
import trends from './trends';

trends.init();

const $title = $('#categoryTitle');

if (page.isMobile() && $title.length) {
    import('../shared/panelCollapse').then(({default: panelCollapse}) => panelCollapse.init($title, 5));
}
